import React, { useMemo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'reactstrap';
import uniqueId from 'lodash/uniqueId';

const InfoIcon = ({ text }: { text: string }) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const toggleTooltip = () => {
    setIsTooltipOpen(!isTooltipOpen);
  };

  const id = useMemo(() => `tooltip-${uniqueId()}`, []);

  if (!text || !text.trim().length) return null;

  return (
    <>
      <FontAwesomeIcon icon={faInfoCircle} className="mx-2" id={id} />
      <Tooltip placement="top" isOpen={isTooltipOpen} target={id} toggle={toggleTooltip}>
        {text.trim()}
      </Tooltip>
    </>
  );
};

export default InfoIcon;
